import './HorizontalLineV2Component.scss';

interface HorizontalLineComponentV2Props {
    className?: string;
    marginBottom?: boolean;
    marginTop?: boolean;
}

const HorizontalLineV2Component = (props: HorizontalLineComponentV2Props) => {
    const {className, marginBottom, marginTop} = props;
    return (
        <div
            className={`horizontal-line-v2-wrapper ${className} + ${marginBottom ? "margin-bottom" : ''} + ${marginTop ? "margin-top" : ''}`}>

        </div>
    );

};

export default HorizontalLineV2Component;
